import { ulid } from 'ulid';
import { TriggerEvent } from '../TriggerEvent';
/**
 * Trigger Container is used to manage all the conditional logic
 * of the trigger events and fire off the event conditions are met.
 */
var TriggerManager = /** @class */ (function () {
    function TriggerManager(context, logger, configs) {
        var _this = this;
        this.context = context;
        this.logger = logger;
        this.configs = configs;
        this.triggerEvents = new Map();
        this.handleTriggerEvent = function (id, event) {
            var _a;
            var triggerEvent = _this.triggerEvents.get(id);
            if (triggerEvent) {
                triggerEvent.active = event.condition;
            }
            var activeEvents = Array.from(_this.triggerEvents.values()).filter(function (e) { return e.active; }).length;
            // make sure all events are active
            if (activeEvents === _this.triggerEvents.size) {
                (_a = _this.onTriggered) === null || _a === void 0 ? void 0 : _a.call(_this);
            }
        };
        if (configs) {
            var _loop_1 = function (eventConfig) {
                var id = "".concat(ulid(), "-").concat(eventConfig.event);
                var event_1 = new TriggerEvent(context, eventConfig);
                event_1.onChanged = function (e) {
                    _this.handleTriggerEvent(id, e);
                };
                this_1.triggerEvents.set(id, {
                    active: false,
                    triggerEvent: event_1
                });
            };
            var this_1 = this;
            for (var _i = 0, configs_1 = configs; _i < configs_1.length; _i++) {
                var eventConfig = configs_1[_i];
                _loop_1(eventConfig);
            }
        }
    }
    TriggerManager.prototype.start = function () {
        var _a;
        if (this.triggerEvents.size === 0) {
            return (_a = this.onTriggered) === null || _a === void 0 ? void 0 : _a.call(this);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        for (var _i = 0, _b = Array.from(this.triggerEvents); _i < _b.length; _i++) {
            var _c = _b[_i], _id = _c[0], eventTrigger = _c[1];
            eventTrigger.triggerEvent.start();
        }
    };
    return TriggerManager;
}());
export { TriggerManager };
//# sourceMappingURL=TriggerManager.js.map